import e from "./objectWithoutPropertiesLoose.js";
//#region \0@oxc-project+runtime@0.142.0/helpers/esm/objectWithoutProperties.js
function t(t, n) {
	if (t == null) return {};
	var r, i, a = e(t, n);
	if (Object.getOwnPropertySymbols) {
		var o = Object.getOwnPropertySymbols(t);
		for (i = 0; i < o.length; i++) r = o[i], n.includes(r) || {}.propertyIsEnumerable.call(t, r) && (a[r] = t[r]);
	}
	return a;
}
//#endregion
export { t as default };
